<script>
  import { createEventDispatcher, onMount } from "svelte";

  export let pagination;
  export let currentPage;

  const dispatch = createEventDispatcher();

  const changePage = (page) => {
    dispatch('change-page', { page });
  }

  $: countPages = pagination.count_pages;

  onMount(() => {
    currentPage = pagination.page;
  })
</script>

{#if countPages !== 1}
  <div class="pagination text-bold">
    {#if currentPage >= 3 && countPages > 3}
      <div class="prev-button pagination__item pointer" on:click={() => changePage(1)}>
        <i class="icon-chevron-left-double" />       
      </div>

      <div class="dots text-bold pagination__item">...</div>
    {/if}

    {#each pagination.visible_pages as page (page) }
      <div 
        class="pagination__item pointer"
        class:active={currentPage === page}
        on:click={() => changePage(page)}
      >
        {page}
      </div>
    {/each}
    
    {#if countPages > 3 && currentPage < countPages - 1}
      <div class="dots pagination__item">...</div>
      
      <div class="next-button pagination__item pointer" on:click={() => changePage(countPages)}>
        <i class="icon-chevron-right-double" />
      </div>
    {/if}
  </div>
{/if}

<style>
  i {
    font-size: 10px;
  }

  .pointer {
    cursor: pointer;
  }

  .pagination {
    display: inline-flex;
    align-items: center;
    font-size: 14px;
    line-height: 20px;
    background-color: #E0E8F6;
    height: 32px;
    border-radius: 30px;
  }

  .pagination__item {
    padding: 6px 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #2B50ED;
    position: relative;
  }

  .pagination__item::after {
    content: '';
    border-left: 1px solid rgba(255, 255, 255, 0.8);
    position: absolute;
  }

  .pagination__item:first-child {
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
  }

  .pagination__item:last-child {
    border-top-right-radius: 30px;
    border-bottom-right-radius: 30px;
  }

  .pagination__item.active {
    background: #576CED;
    color: white;
  }

  .dots {
    color: #8494F1;
    font-size: 14px;
  }
</style>